import * as yup from "yup";

export const LinkDialogValidator = yup.object().shape({
  text: yup.string().required("Name error"),
  url: yup
    .string()
    .url("Invalid URL")
    .test("conditionally-required", "URL is required", (value) => {
      const hasValue = Boolean(value?.trim());
      const touched = this?.options?.context?.touchedUrl;

      return !hasValue ? !touched : true;
    }),
});

export const TableDialogValidator = yup.object().shape({
  columns: yup
    .number()
    .required("Columns required")
    .min(1, "Columns must be at least 1")
    .max(15, "Columns must be at most 15"),
  rows: yup.number().required("Rows required").min(1, "Rows must be at least 1").max(100, "Rows must be at most 100"),
});

export const CodeBlockDialogValidator = yup.object().shape({
  language: yup.string().required(),
  code: yup.string().required(),
});
